import React, { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import { Helmet } from 'react-helmet-async';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Box, Button, Center, Spinner, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import DocumentSignModal from 'presentation/containers/modules/onlineDocuments/DocumentSigningModal';
import AppRoute from 'router/AppRoute';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const DocumentDetailPage: FC = () => {
  const location = useLocation();
  const document = location.state.document;
  const navigate = useNavigate();
  const [numPages, setNumPages] = useState<number>(0);
  const { t } = useTranslation();
  const {
    isOpen: isSignDocModalOpen,
    onOpen: openSignDocumentModal,
    onClose: closeSignModal,
  } = useDisclosure();

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }
  const [isLoading, setLoading] = useState<boolean>(true);

  const content = <Box height={isLoading ? '0px' : '100%'} maxHeight={isLoading ? '0px' : '750px'} overflow="auto">
    <Document file={document.upload.url} onLoadSuccess={onDocumentLoadSuccess}>
    {Array.from(new Array(numPages), (el, index) => (
      <Page key={`page_${index + 1}`} pageNumber={index + 1} renderTextLayer={false} onLoadSuccess={page => { setLoading(false); }}
            renderAnnotationLayer={false}/>
    ))}
    </Document>
  </Box>;

  return <>
  <SettingsLayout>
    <Helmet>
      <title>{document.name}</title>
    </Helmet>
    <GridHeading>{document.name}</GridHeading>
    <AppCard p="40px">
      {isLoading && (<Box h="750px"><Center p={5} key="loading">
        <Spinner />
      </Center></Box>)}
      {content}
      <DocumentSignModal
        isOpen={isSignDocModalOpen}
        onClose={closeSignModal}
        documentId={document.id}
        onSuccess={() => navigate(AppRoute.documentDetail(document.id), { state: { document: { ...document, isSigned: true } }, replace: true })}
      />
      {!document.isSigned && (<Button onClick={() => { openSignDocumentModal(); }}>
        {t('sign')}
      </Button>)}
    </AppCard>
  </SettingsLayout>
</>;
};

export default DocumentDetailPage;
